export const appName = 'calls';
